import {useEffect, useMemo, useState} from "react";
import {getFormRepository} from "infrastructure/di/container";
import {GuideKey} from "core/constants/guideKeys";
import {GUIDE_KEYS} from "constants/app";

export function useInitializeGuides(token: string, guia?: GuideKey) {
    const [ready, setReady] = useState(false);
    const [error, setError] = useState<Error | null>(null);
    const repo = useMemo(() => getFormRepository(), []);

    useEffect(() => {
        if (!token) return;

        let mounted = true;
        setReady(false);
        setError(null);

        async function loadGuides() {
            try {
                if (guia) {
                    await repo.getGuideByKey(GUIDE_KEYS.I);
                    await repo.getGuideByKey(guia);
                    if (!mounted) return;
                    setReady(true);
                } else {
                    await repo.init();
                    if (!mounted) return;
                    setReady(true);
                }
            } catch (err) {
                if (!mounted) return;
                setError(err as Error);
            }
        }

        loadGuides();

        return () => {
            mounted = false;
        };
    }, [token, guia, repo]);

    return {ready, error};
}
